import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/carousel/style.scss";
import "@ingka/tabs/style.scss";
import "@ingka/focus/style.scss";
import Tabs, { Tab, TabPanel } from "@ingka/tabs";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateDashboardTabSelected } from "../../store/globalSlice";
import { TAB_KEYS } from "../../utils/dasboard-tab-keys";
import { useEffect } from "react";

export default function MyTab({tabs, tabPanels, defaultTab}) {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const dashboardTabSelected = useSelector(
    (state) => state.global.dashboardTabSelected
  )

  useEffect(()=>{
    // reset dashboadTabSelected
    if(dashboardTabSelected !== TAB_KEYS.COMMERCIAL)
    dispatch(updateDashboardTabSelected(TAB_KEYS.COMMERCIAL));
  },[])

  const onTabChanged = (a) => {
    let tabKey = TAB_KEYS.COMMERCIAL;
    switch (a) {
      case t("dashboard.customer"):
        tabKey = TAB_KEYS.CUSTOMER;
        break;
      case t("dashboard.productivity"):
        tabKey = TAB_KEYS.PRODUCTIVITY;
        break;
      case t("dashboard.logistic"):
        tabKey = TAB_KEYS.LOGISTIC;
        break;
      default:
    }
    dispatch(updateDashboardTabSelected(tabKey));
  };

  return (
    <Tabs 
      tabs={
        tabs.map((tab, index) =>
          <Tab key={index} {...tab}/>
        )
      } 
      tabPanels={
        tabPanels.map((panel, index) =>
          <TabPanel key={index} {...panel}/>
        )
      } 
      defaultActiveTab={defaultTab}
      onTabChanged={onTabChanged}
      />
  )
}
